import React from 'react';

export const Ring = ({
  className,
  color,
  width,
  height
}: {
  className?: string;
  color?: string;
  width?: number;
  height?: number;
}) => (
  <svg
  width={width ?? 21}
  height={height ?? 21}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.17949 14.1666H4.59616V8.75C4.59616 5.29822 7.39438 2.5 10.8462 2.5C14.2979 2.5 17.0962 5.29822 17.0962 8.75V14.1666H17.5128C17.9731 14.1666 18.3462 14.5397 18.3462 15C18.3462 15.4602 17.9731 15.8333 17.5128 15.8333L4.17949 15.8333C3.71926 15.8333 3.34616 15.4602 3.34616 15C3.34616 14.5397 3.71926 14.1666 4.17949 14.1666ZM10.8462 4.16667C8.31486 4.16667 6.26283 6.21869 6.26283 8.75V14.1666L15.4295 14.1666V8.75C15.4295 6.21869 13.3775 4.16667 10.8462 4.16667Z"
      fill={color ?? '#7D7A9A'}
    />
    <path
      d="M9.20506 16.4711C9.11579 16.2689 9.06984 16.0522 9.06984 15.8333H12.6225C12.6225 16.0522 12.5765 16.2689 12.4873 16.4711C12.398 16.6733 12.2672 16.8571 12.1022 17.0118C11.9373 17.1666 11.7414 17.2894 11.5259 17.3731C11.3104 17.4569 11.0794 17.5 10.8462 17.5C10.6129 17.5 10.3819 17.4569 10.1664 17.3731C9.95088 17.2894 9.75506 17.1666 9.59011 17.0118C9.42517 16.8571 9.29433 16.6733 9.20506 16.4711Z"
      fill={color ?? '#7D7A9A'}
    />
  </svg>
);
